import { Controller } from "react-hook-form";
import { useLocalization } from "@fluent/react";
import { ContentCard, TextInput } from "@narmi/design_system";

import InstitutionDetails from "./InstitutionDetails";
import styles from "./InternationalWireForm.module.scss";

import type { SwiftDestinationFormType } from "byzantine/src/dbbl/businessLogic/entities/recipients";
import type { SwiftInstitution } from "byzantine/src/dbbl/businessLogic/modules/recipientDrawer";
import type { Control } from "react-hook-form";

interface CorrespondentBankFieldsProps {
  control: Control<SwiftDestinationFormType>;
  institution: SwiftInstitution | null;
  isLoadingInstitution: boolean;
  // the BIC lookup's error
  bicError?: string;
  // the API's error from the last save
  apiError?: string;
  onBicBlur: (bic: string) => void;
}

const CorrespondentBankFields = ({
  control,
  institution,
  isLoadingInstitution,
  bicError,
  apiError,
  onBicBlur,
}: CorrespondentBankFieldsProps) => {
  const { l10n } = useLocalization();
  return (
    <ContentCard kind="plain" paddingSize="none">
      <p className={`fontColor--secondary ${styles.sectionSubHeader}`}>
        {l10n.getString("international-wire-drawer-correspondent-bank-details")}
      </p>
      <Controller
        name="correspondent_bank_bic"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            {...field}
            value={field.value || ""}
            onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
              field.onBlur();
              onBicBlur(event.target.value);
            }}
            field="correspondent_bank_bic"
            label={l10n.getString("swift-bic")}
            error={error?.message || bicError || apiError}
          />
        )}
      />
      {!apiError ? (
        <InstitutionDetails
          isLoading={isLoadingInstitution}
          institution={institution}
        />
      ) : null}
    </ContentCard>
  );
};

export default CorrespondentBankFields;
